var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout"},[_c('app-header',{staticClass:"page-layout-nav"}),_c('main',{staticClass:"page-layout-body"},[_vm._t("default"),_c('app-footer')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }